import React, { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import NetworkStatus from "./NetworkStatus";
import { AppState } from "../App";
import { Link } from "react-router-dom";
import { useWeb3 } from "../contexts/Web3Context";
import { FaSignOutAlt } from "react-icons/fa";

function HomeHeader() {
  const useAppState = useContext(AppState);
  const { isWalletConnected, isContractReady, provider } = useWeb3();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isContractReady && isWalletConnected) {
      setIsLoggedIn(true);
    }
  }, [isContractReady, isWalletConnected]);

  const handlePageRefresh = () => {
    window.location.reload();
  };

  return (
    <header className="sticky top-0 w-full z-50">
      <nav className="shadow-md py-2.5 bg-[#181a1e] rounded-lg">
        <div className="flex flex-wrap items-center justify-between max-w-screen-2xl px-4 mx-auto">
          <Link to={"/"} className="flex items-center">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-2xl font-bold text-black dark:text-white cursor-pointer"
              onClick={() => scrollToSection("home")}
            >
              <div className="flex items-center">
                <img
                  src="logo.png"
                  className="h-6 mr-0 sm:h-6"
                  alt="Landwind Logo"
                />
                <span className="text-primary mb-1">bnb</span>
              </div>
            </motion.div>
          </Link>
          <div className="flex items-center lg:order-2 gap-2">
            <NetworkStatus provider={provider} />
            {isLoggedIn ? (
              <div className="flex items-center gap-4 ml-4">
                <button
                  onClick={() => useAppState.navigate("/dashboard")}
                  className="h-[32px] flex items-center justify-center text-white bg-green-500 hover:bg-green-500/90 focus:ring-4 focus:ring-primary/30 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 sm:mr-2 lg:mr-0 dark:bg-green-500 dark:hover:bg-green-500/90 focus:outline-none dark:focus:ring-primary/40"
                >
                  Dashboard
                </button>
                {/*<button
                  onClick={() => useAppState.Logout()}                  
                >
                  <FaSignOutAlt className="w-6 h-6 text-red-500" />
                </button>*/}
              </div>
            ) : (
              <button
                onClick={handlePageRefresh}
                className="h-[32px] flex items-center justify-center bg-primary text-white px-4 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
              >
                Connect Wallet
              </button>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
}

export default HomeHeader;
